import { lightColors, mapLightTheme } from './LightTheme';

export const GCashTheme = mapLightTheme(lightColors, {
  colorCurrencyIcon: '#fff',
  colorModeCurrencyIcon: 'colorful',
});
